<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Treballs Finals')"></BreadcrumSection>

    <h1>{{ $t("Treballs Finals") }}</h1>

    <MaterialsCommon init-query="activitat_comunitat:pfc" router-name="treballsFinals"></MaterialsCommon>

  </div>

</template>

<script>

import store from "@/store";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {setMetadata} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

export default {
  name: "TreballsFinalsView",
  components: {
    MaterialsCommon,
    BreadcrumSection
  },

  setup(){
    const route = useRoute();
    const { t } = useI18n();

    onMounted(async () => {
      setMetadata(t('Treballs Finals'))
      await store.dispatch('updateSearchSelected', "Treballs Finals");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-turquoise.webp') });
    });

    return{
    }
  }
}

</script>

<style scoped>
</style>
